export const getSourceType = (): string => {
  let returnVal = 'accounts'
  if (window.location.href.indexOf('/hq') > -1) {
    returnVal = 'hq'
  }
  return returnVal
}
